import React from 'react'

export default React.createContext({
  accessToken: null,
  refreshToken: null,
  accessTokenExpires: null,
  refreshTokenExpires: null,
  isAuthenticated: false,
  user: {}
})
